/* eslint-disable */
// TODO: check es lint errors
import animate from 'motion/animate'

const easeInOutQuart = t =>
  t < 0.5 ? +8.0 * Math.pow(t, 4.0) : -8.0 * Math.pow(t - 1.0, 4.0) + 1.0

const scrollTo = (
  target,
  offset = 0,
  duration = 1000,
  container = window,
  type = 'y'
) => {
  const scrollY = container.scrollY || window.pageYOffset
  const scrollX = container.scrollLeft

  let scrollTarget = target.getBoundingClientRect().top + scrollY - offset
  let scroll = scrollY
  if (type === 'x') {
    scroll = scrollX
    scrollTarget = -offset
  }
  animate({
    from: scroll,
    to: scrollTarget, //Math.min(maxScrollPosition, scrollTarget),
    duration,
    cb: scr => {
      if (type === 'x') {
        container.scrollTo(scr, 0)
      } else {
        container.scrollTo(0, scr)
      }
    },
    ease: easeInOutQuart
  })
}

export default scrollTo
/* eslint-enable */
